export default __webpack_public_path__ + "static/media/gallery_05.f557f263.jpg";